/**
 * Backend B2B tax setup error codes (`errorCode` in the response body) and
 * the translation keys that explain them to the admin.
 */
export const B2B_TAX_ERROR_KEYS: Record<string, string> = {
  B2B_TAX_IDENTITY_FORBIDDEN: 'b2b.tax.error.forbidden',
  B2B_TAX_IDENTITY_MISSING: 'b2b.tax.error.missing'
};

/**
 * The message for a failed tax setup call: a translated text for a known B2B
 * code, else the server message, else the given fallback.
 */
export const taxSetupErrorMessage = (
  error: any,
  t: (key: string) => string,
  fallback: string
): string => {
  const data = error?.response?.data;
  const key = data?.errorCode ? B2B_TAX_ERROR_KEYS[data.errorCode] : undefined;
  if (key) return t(key);
  return data?.message || fallback;
};

/**
 * Tax fields are part of the response only on a backend that has the B2B tax
 * setup. A key that is present (even null) means it can be edited; absent
 * means an older backend, which would reject the fields with a 400.
 */
export const hasTaxSetupSupport = (
  entity: object | null | undefined,
  key: 'taxIdentity' | 'taxIdNumber'
): boolean => !!entity && key in entity;
